module.exports = __webpack_public_path__ + "static/7-246251e0493ca1178b9e4dcd0e69cd3d.jpg";